module.exports = __webpack_public_path__ + "static/media/inclusion-banner.16f67ba0.webp";